import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const Field = ({ id, label, required, children }) => (
  <div className="space-y-1.5">
    <Label htmlFor={id}>{label}{required && <span className="text-red-600"> *</span>}</Label>
    {children}
  </div>
);

export const JamaahFields = ({ form, set, prefix, showPhone = true }) => (
  <>
    <Field id={`${prefix}-name`} label="Nama Lengkap" required>
      <Input id={`${prefix}-name`} value={form.name} onChange={(e) => set("name", e.target.value)} required placeholder="Nama sesuai KTP" data-testid={`${prefix}-name-input`} />
    </Field>
    <div className="grid grid-cols-3 gap-3">
      <Field id={`${prefix}-gender`} label="Jenis Kelamin">
        <Select value={form.gender} onValueChange={(v) => set("gender", v)}>
          <SelectTrigger id={`${prefix}-gender`} data-testid={`${prefix}-gender-select`}><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="L">Laki-laki</SelectItem>
            <SelectItem value="P">Perempuan</SelectItem>
          </SelectContent>
        </Select>
      </Field>
      <Field id={`${prefix}-rt`} label="RT">
        <Input id={`${prefix}-rt`} value={form.rt} onChange={(e) => set("rt", e.target.value)} placeholder="05" data-testid={`${prefix}-rt-input`} />
      </Field>
      <Field id={`${prefix}-rw`} label="RW">
        <Input id={`${prefix}-rw`} value={form.rw} onChange={(e) => set("rw", e.target.value)} placeholder="06" data-testid={`${prefix}-rw-input`} />
      </Field>
    </div>
    {showPhone && (
      <Field id={`${prefix}-phone`} label="No. HP / WA (untuk masuk)" required>
        <Input id={`${prefix}-phone`} type="tel" value={form.phone} onChange={(e) => set("phone", e.target.value)} required placeholder="081234567890" data-testid={`${prefix}-phone-input`} />
      </Field>
    )}
    <Field id={`${prefix}-address`} label="Alamat">
      <Textarea id={`${prefix}-address`} rows={2} value={form.address} onChange={(e) => set("address", e.target.value)} placeholder="Dusun Banjarwaru ..." data-testid={`${prefix}-address-input`} />
    </Field>
    <Field id={`${prefix}-notes`} label="Catatan (opsional)">
      <Textarea id={`${prefix}-notes`} rows={2} value={form.notes} onChange={(e) => set("notes", e.target.value)} data-testid={`${prefix}-notes-input`} />
    </Field>
  </>
);
